// extracted by mini-css-extract-plugin
export var container = "Layout-module--container--008e3";
export var skip = "Layout-module--skip--25156";